import { AllocationCalendarSlot, AllocationViewListSearchCriteria } from '../models';
import { LocalDateRangeModel } from '../../../../models';

export class AllocationViewCalendarLoad {
  public static readonly type = '[AllocationViewCalendar] Load';
  constructor(public payload: AllocationViewListSearchCriteria, public callback?: () => void) {}
}

export class AllocationViewCalendarSelectSlot {
  public static readonly type = '[AllocationViewCalendar] Select Slot';
  constructor(public payload: AllocationCalendarSlot) {}
}

export class AllocationViewCalendarUpdateDocksAfterDrop {
  public static readonly type = '[AllocationViewCalendar] UpdateDocks After Drop';
  constructor(
    public payload: {
      slotId: number;
      originalDockId: number;
      allocationDockId: number;
      timeRange: LocalDateRangeModel;
    },
  ) {}
}

export class AllocationViewCalendarInitialState {
  public static readonly type = '[AllocationViewCalendar] Set Initial State';
}
